import styled from "styled-components";

export const TableContainer = styled.div`
  height: 2000px;
  overflow-y: auto;
  
  &::-webkit-scrollbar {
		width: 6px;
    height: 6px;
	}

	&::-webkit-scrollbar-thumb {
		background-color: #8b8b8b;
		border-radius: 4px;
	}

	&::-webkit-scrollbar-track {
		background-color: #f5f5f5;
	}
`;

export const FiltersRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 8px;
`;

export const FilterSelectWrap = styled.div`
  flex: 1 1 140px;
  min-width: 120px;
`;

export const FilterSelect = styled.select`
  flex: 1 1 140px;
  min-width: 120px;
  padding: 6px 8px;
  border: 1px solid #E9EBEF;
  border-radius: 4px;
  background: #fff;
  color: #000;
  font-family: 'Saira Semi Condensed', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const ClearButton = styled.button`
  padding: 6px 10px;
  border: 1px solid #E9EBEF;
  border-radius: 4px;
  background: #f7f7f7;
  color: #000;
  font-family: 'Saira Semi Condensed', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const PlayersTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
    
  th {
      border-bottom: 1px solid #E9EBEF;
      text-align: left;
      color: #000;
      font-family: 'Saira Semi Condensed', sans-serif;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      padding: 8px;
      position: sticky;
      top: 0;
      background: #fff;
      z-index: 2;
  }
  td {
      text-align: left;
      padding: 8px;
      color: #000;
      font-family: 'Saira Semi Condensed', sans-serif;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      border-bottom: 1px solid #E9EBEF;
      img{
          width: 50px;
          height: 50px;
      }
  }
  .empty-state {
      text-align: center;
      color: #6b6b6b;
      font-size: 14px;
      padding: 12px 8px;
  }
`;
